"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hc = exports.handleDomStyle = exports.getStyle = exports.getOriginalStyle = exports.getDomSize = exports.getDomParents = exports.getDomParent = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _defineProperty2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _index = require("./index.js");
// 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
var getOriginalStyle = exports.getOriginalStyle = function () {
  if (window.document.currentStyle) {
    return function (dom, attr) {
      var a = function a(b, c) {
        return b.currentStyle[c];
      };
      return Array.isArray(attr) ? attr.map(function (i) {
        return a(dom, i);
      }) : a(dom, attr);
    };
  } else {
    return function (dom, attr) {
      var a = function a(b, c) {
        return getComputedStyle(b, false)[c];
      };
      return Array.isArray(attr) ? attr.map(function (i) {
        return a(dom, i);
      }) : a(dom, attr);
    };
  }
}();
var hc = exports.hc = function hc(a) {
  var b = function b(aa) {
    return aa.includes('%') ? +document.body.clientWidth * (+aa.replace(/\%/g, '') / 100) : +aa.replace(/\px/g, '');
  };
  return Array.isArray(a) ? a.map(function (item) {
    return b(item);
  }) : b(a);
};

/** 获取dom对象的尺寸
 * @description: 获取dom对象的尺寸
 * @param { Object } dom dom 对象
 * @param { String } style 需要获取的尺寸字段
 * @param { Boolean } isOriginal 是否是要原先的？
 * @return { Number | String } 返回尺寸
 */
var getDomSize = exports.getDomSize = function getDomSize(dom, style) {
  var isOriginal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if ((0, _index.dataTypeOf)(dom).includes('html') && (0, _index.dataTypeOf)(dom).includes('element') && style) {
    var a = getOriginalStyle(dom, style);
    return isOriginal ? a : hc(a);
  }
  return null;
};

/** 获取dom对象的尺寸
 * @description: 获取dom对象的尺寸
 * @param { Object } dom dom 对象
 * @param { String | Array } style 需要获取的尺寸字段
 * @param { Boolean } isOriginal 是否是要原先的？
 * @return { Object } 返回尺寸 对象
 */
var getStyle = exports.getStyle = function getStyle(dom, style) {
  var isOriginal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var styleArr = [];
  var styleObj = {};
  if ((0, _index.dataTypeOf)(dom).includes('html') && (0, _index.dataTypeOf)(dom).includes('element') && style) {
    switch ((0, _index.dataTypeOf)(style)) {
      case 'array':
        styleArr.push.apply(styleArr, (0, _toConsumableArray2.default)(style));
        break;
      case 'string':
        styleArr.push(style);
        break;
    }
    styleArr.forEach(function (s) {
      var a = getOriginalStyle(dom, s);
      var sty = isOriginal ? a : hc(a);
      Object.assign(styleObj, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, s, sty), (0, _index.alterNomenclature)(s), sty));
    });
  }
  return styleObj;
};

/** 获取 dom 元素的父元素
 * @description: 获取dom元素的父元素
 * @param { Object } dom 目标dom
 * @return { Object } dom 的父元素
 */
var getDomParent = exports.getDomParent = function getDomParent(dom) {
  return dom.parentNode;
};

/** 获取dom元素的祖宗列表
 * @description: 获取dom元素的祖宗列表，返回一个数组，数组是当前dom元素的族谱
 * @param { Object } dom 目标dom
 * @param { Array | String } field 指定获取的字段，如果为空，则返回整个dom元素，如果有指定，则返回dom对象的指定参数
 * @return { Array } dom 的族谱
 */
var getDomParents = exports.getDomParents = function getDomParents(dom, field) {
  var el;
  if ((0, _index.dataTypeOf)(dom).includes('element')) el = dom;else if (dom !== null && dom !== void 0 && dom.$el && (0, _index.dataTypeOf)(dom === null || dom === void 0 ? void 0 : dom.$el).includes('element')) el = dom.$el;else return console.warn(dom, "\u4E0D\u662F document \u6807\u7B7E\u5143\u7D20 \u4E5F\u4E0D\u662F vue \u5B9E\u4F8B\u5BF9\u8C61");
  var arr = [el];
  while ((_arr$ = arr[0]) !== null && _arr$ !== void 0 && _arr$.parentNode) {
    var _arr$;
    arr.unshift(arr[0].parentNode);
  }
  var r = function r(f) {
    return f === 'all' || f === '' || f === 'dom' || f === 'document' || typeof f === 'boolean' && f;
  };

  // return arr.map($el => field ? $el[field] : $el)
  return arr.map(function ($el) {
    if (typeof field === 'string') return field ? $el[field] : $el;else if (Array.isArray(field)) return field.map(function (f) {
      return r(f) ? $el : $el[f];
    });else if ((0, _typeof2.default)(field) === 'object') {
      var obj = {};
      Object.keys(field).forEach(function (f) {
        return r(f) ? obj[f] = $el : obj[f] = $el[f];
      });
      return obj;
    }
    return $el;
  });
};

/** 处理dom样式
 * @description: 如果属性中接受的样式是 function,那么获取该方法的值，如果是对象，则保留，如果是字符串，则转变为对象
 * @param { Function | Object | String } styles 目标dom
 * @return { Object } style
 */
var _handleDomStyle = exports.handleDomStyle = function handleDomStyle(styles) {
  if ((0, _index.isEmpty)(styles)) return {};else if ((0, _index.dataTypeOf)(styles) === 'function') return _handleDomStyle(styles.apply(void 0, (0, _toConsumableArray2.default)(Array.prototype.slice.call(arguments).slice(1))));else if ((0, _index.dataTypeOf)(styles) === 'object') return styles;else if ((0, _index.dataTypeOf)(styles) === 'string') {
    var _styles$split;
    var stylesObj = {};
    styles === null || styles === void 0 || (_styles$split = styles.split(';')) === null || _styles$split === void 0 || (_styles$split = _styles$split.filter(function (style) {
      return style;
    })) === null || _styles$split === void 0 || (_styles$split = _styles$split.map(function (style) {
      return style.split(':');
    })) === null || _styles$split === void 0 || (_styles$split = _styles$split.filter(function (style) {
      return Array.isArray(style) && style[0] && style[1];
    })) === null || _styles$split === void 0 || _styles$split.forEach(function (style) {
      return stylesObj[style[0]] = style[1];
    });
    return stylesObj;
  }
  return {};
};